import _ from 'lodash';
import React, { useCallback,useState } from 'react';
import { wizardProps, WizardPage } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react'
import { validationUtil } from 'premier-capability-hooks';
import { UWIssuesUtil } from "premier-policycommon-util-js";
import styles from './DeclarationStyles.scss';
import presentationMetadata from './DeclarationPage.metadata.json5';
import messages from './DeclarationPage.messages';


const PAYMENT_METHOD = {
    bank: 'wire',
    credit: 'creditcard'
}; 

function DeclarationPage(props) {
    const { onValidate } = useValidation('DeclarationPage');
    const {
        wizardData: submissionVM,
        updateWizardData,
        currentStep,
        disableNext,
        callbackMap
    } = props;

    const { authHeader } = useAuthentication();
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const [notifications, setNotifications] = useState([]); 
    const [underwritingIssues, setUnderwritingIssues] = useState([]); 

    const { pageKey } = currentStep;
    // eslint-disable-next-line security/detect-object-injection
    const metadata = presentationMetadata[pageKey];

    const findBlockingPoint = UWIssuesUtil.findBlockingPoint(underwritingIssues);
        
    const formatPaymentData = useCallback(() => {
        const paymentDetailsPath = 'bindData.paymentDetails';
        const paymentMethod = _.get(submissionVM, `${paymentDetailsPath}.paymentMethod.value`);

        if (paymentMethod === PAYMENT_METHOD.bank) {
            _.set(submissionVM, `${paymentDetailsPath}.creditCardData`, undefined);
        } else if (paymentMethod === PAYMENT_METHOD.credit) {
            _.set(submissionVM, `${paymentDetailsPath}.bankAccountData`, undefined);
        }

        return submissionVM.value;
    }, [submissionVM]);

    
    const hasDeclarationSigned = useCallback(() => !(_.get(submissionVM.value, `bindData.hasDeclarationSigned`)),[submissionVM]);

    const handleNext = useCallback(async () => {
        const oldIssues = notifications;
        
        setNotifications([]); 

        submissionVM.value = await LoadSaveService.bindSubmission(formatPaymentData(), authHeader);
        
        if(_.isEqual( _.get(submissionVM.value, 'baseData.periodStatus',''), 'Bound')) {
             _.set(submissionVM, 'errorsAndWarnings.validationIssues.value', {});
                            
            return submissionVM;
        }

        const errorsAndWarnings = _.get(submissionVM.value, `errorsAndWarnings`, {});
        const notificationData = validationUtil.handleEdgeError(errorsAndWarnings, oldIssues);

        const uwIssues = _.get(submissionVM.value, `errorsAndWarnings.underwritingIssues`, {});
        
        if(!_.isUndefined(uwIssues) && !_.isEmpty(uwIssues)) {
            _.each(uwIssues, (uwIssue) => _.set(uwIssue, 'offering', 'CUSTOM'));
            setUnderwritingIssues(uwIssues)
        }
        
        if (_.isUndefined(uwIssues) && !notificationData.hasNewIssues && !notificationData.containsError) {
             _.set(submissionVM, 'errorsAndWarnings.validationIssues.value', {});
            
              return submissionVM;
        } 

        setNotifications(notificationData.issuesList);
        window.scrollTo(0,0);
        
        return false;

    }, [LoadSaveService, authHeader, formatPaymentData, notifications, submissionVM]);

    const resolveClassNameMap={styles};
    

    const resolveCallbackMap = {
        ...callbackMap,
        onValidate
    };

    const onSave = useCallback(async () => {
        await LoadSaveService.updateDeclaration_Ext(submissionVM.value.quoteID, submissionVM.value.bindingData, authHeader);
    }, [LoadSaveService, authHeader, submissionVM]);

     const overrideProps = {
        customNotification: {
            content: validationUtil.getNotificationsContent(notifications)
        },
        underWritingIssues: {
            underwritingIssues,
            blockQuote: findBlockingPoint,
            filterUWIssuesInCustomOffering: false,
            quoteID: _.get(submissionVM.value, 'quoteID'),
            accountNumber: _.get(submissionVM.value, 'baseData.accountNumber')
        }
    };

    return (
        <WizardPage
            nextLabel={messages.paymentBuyNow}
            onNext={handleNext}
            onSave={onSave}
            disableNext={disableNext || hasDeclarationSigned()}
            disableSave={disableNext || hasDeclarationSigned()}
        >
            <ViewModelForm
                uiProps={metadata.content}
                model={submissionVM}
                onModelChange={updateWizardData}
                callbackMap={resolveCallbackMap}
                onValidationChange={onValidate}
                overrideProps={overrideProps}
                classNameMap={resolveClassNameMap}
            />
        </WizardPage>
    );
}

DeclarationPage.propTypes = wizardProps;
export default DeclarationPage;
